export interface LineDiff {
  added: string[];
  removed: string[];
}

function countLines(text: string): Map<string, number> {
  const counts = new Map<string, number>();
  for (const line of text.split("\n")) {
    counts.set(line, (counts.get(line) ?? 0) + 1);
  }
  return counts;
}

export function diffLines(current: string, base: string): LineDiff {
  const inBase = countLines(base);
  const inCurrent = countLines(current);

  const added: string[] = [];
  for (const line of current.split("\n")) {
    const remaining = inBase.get(line) ?? 0;
    if (remaining > 0) {
      inBase.set(line, remaining - 1);
      continue;
    }
    if (line.trim().length > 0) added.push(line);
  }

  const removed: string[] = [];
  for (const line of base.split("\n")) {
    const remaining = inCurrent.get(line) ?? 0;
    if (remaining > 0) {
      inCurrent.set(line, remaining - 1);
      continue;
    }
    if (line.trim().length > 0) removed.push(line);
  }

  return { added, removed };
}
